import React, { useState, useEffect, useRef } from 'react';
import { consultarDNI } from '../../services/consultar_dni';
// Importamos authService para obtener el usuario (opcional)
import { authService } from '../../services/authService'; // Ajusta la ruta según tu proyecto


const Verificarcodigo = () => {
  const [documento, setDocumento] = useState('');
  const [nombreCompleto, setNombreCompleto] = useState('');
  const [estadoAfiliacion, setEstadoAfiliacion] = useState('');
  const [mostrarBotonAfiliar, setMostrarBotonAfiliar] = useState(false);
  const [buscando, setBuscando] = useState(false);
  const [mensajeError, setMensajeError] = useState(null);
  const [mostrarResultados, setMostrarResultados] = useState(false);

  // Estado para los datos de la licencia
  const [licencia, setLicencia] = useState({ tipo: '', consultasRestantes: 0 });

  const tareasPendientesRef = useRef(0);

  // Cargar datos del usuario desde localStorage al montar el componente
  useEffect(() => {
    const user = authService.getCurrentUser(); // o directamente JSON.parse(localStorage.getItem('user'))
    if (user && user.licencia) {
      setLicencia({
        tipo: user.licencia.tipo || 'Gratuita',
        consultasRestantes: user.licencia.consultas_restantes ?? 0,
      });
    } else {
      // Si no hay usuario, se asume sin licencia (puedes ocultar la info)
      setLicencia({ tipo: 'Sin licencia', consultasRestantes: 0 });
    }
  }, []);

  const mostrarToast = (mensaje, esError = true) => {
    if (esError) {
      setMensajeError(mensaje);
      setTimeout(() => setMensajeError(null), 3000);
    }
  };

  const verificarAfiliacion = async (dni) => {
    try {
      const response = await fetch('https://eworld.dxn2u.com/s/apinewreg/beforesubmitcheck', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ icno: dni, country_id: 'PE' }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      const jsonResponse = await response.json();
      const messageIcno = jsonResponse.message_icno || '';

      if (messageIcno.includes('already in use')) {
        setEstadoAfiliacion('Ya tiene código de afiliación');
        setMostrarBotonAfiliar(false);
      } else {
        setEstadoAfiliacion('Disponible para afiliación');
        setMostrarBotonAfiliar(true);
      }
    } catch (error) {
      mostrarToast(`Error: ${error.message}`);
    } finally {
      verificarYHabilitarBoton();
    }
  };

  const obtenerDatosPorDNI = async (dni) => {
    try {
      const result = await consultarDNI(dni);

      if (!result.success || result.status_code !== 200) {
        mostrarToast(result.message || 'Error en consulta DNI');
        setNombreCompleto('');
        return;
      }

      // ====== NUEVO: Actualizar consultas restantes en localStorage ======
      if (result.consultas_restantes !== undefined) {
        // Obtener usuario actual
        const currentUser = authService.getCurrentUser();
        if (currentUser) {
          // Actualizar la licencia con el nuevo saldo
          const updatedUser = {
            ...currentUser,
            licencia: {
              ...currentUser.licencia,
              consultas_restantes: result.consultas_restantes
            }
          };
          authService.updateUser(updatedUser);
          
          // Actualizar también el estado local para reflejar el cambio en UI
          setLicencia(prev => ({
            ...prev,
            consultasRestantes: result.consultas_restantes
          }));
        }
      }
      // ================================================================

      let nombre = '';
      if (result.raw?.comprobante) {
        const { apePaterno, apeMaterno, nomPerNat } = result.raw.comprobante;
        nombre = `${apePaterno} ${apeMaterno} ${nomPerNat}`.trim();
      } else if (result.nombreCompleto && result.nombreCompleto !== 'No encontrado') {
        nombre = result.nombreCompleto;
      }

      setNombreCompleto(nombre || '');
      if (!nombre) mostrarToast('DNI no encontrado');
    } catch (error) {
      mostrarToast('Error al consultar DNI');
    } finally {
      verificarYHabilitarBoton();
    }
  };


  const verificarYHabilitarBoton = () => {
    tareasPendientesRef.current -= 1;
    if (tareasPendientesRef.current <= 0) {
      setBuscando(false);
      tareasPendientesRef.current = 0;
    }
  };

  const handleBuscar = () => {
    if (licencia.consultasRestantes <= 0) {
      mostrarToast('No tienes consultas disponibles. Contacta con soporte.');
      return;
    }

    const docLimpio = documento.replace(/\s+/g, '');
    if (!docLimpio) {
      mostrarToast('Ingrese el DNI');
      return;
    }
    if (docLimpio.length !== 8) {
      mostrarToast('DNI debe tener 8 dígitos');
      return;
    }

    tareasPendientesRef.current = 2;
    setBuscando(true);
    setMostrarResultados(false);
    setMensajeError(null);

    verificarAfiliacion(docLimpio);
    obtenerDatosPorDNI(docLimpio);
  };

  useEffect(() => {
    if (nombreCompleto || estadoAfiliacion) {
      setMostrarResultados(true);
    }
  }, [nombreCompleto, estadoAfiliacion]);

  // Determinar si el botón debe estar deshabilitado
  const isButtonDisabled = buscando || licencia.consultasRestantes <= 0;

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.iconWrapper}>
            <svg style={styles.icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h2 style={styles.title}>Verificación de Afiliado</h2>
          <p style={styles.subtitle}>Consulte estado de afiliación DXN</p>
        </div>

        {/* === NUEVO: Información de licencia === */}
        <div style={styles.licenciaContainer}>
          <div style={styles.licenciaItem}>
            <span style={styles.licenciaLabel}>Tipo de licencia</span>
            <span style={styles.licenciaValor}>{licencia.tipo}</span>
          </div>
          <div style={styles.licenciaItem}>
            <span style={styles.licenciaLabel}>Consultas restantes</span>
            <span style={{
              ...styles.licenciaValor,
              color: licencia.consultasRestantes <= 0 ? '#dc2626' : '#059669',
            }}>
              {licencia.consultasRestantes}
            </span>
          </div>
        </div>

        {/* Input y Botón */}
        <div style={styles.inputSection}>
          <label style={styles.label}>Número de DNI</label>
          <div style={styles.inputContainer}>
            <div style={styles.inputWrapper}>
              <svg style={styles.inputIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a1 1 0 112 0v1m-1 0a1 1 0 10-2 0v1m-4 0h6" />
              </svg>
              <input
                type="text"
                placeholder="Ingrese 8 dígitos"
                value={documento}
                onChange={(e) => setDocumento(e.target.value.replace(/\D/g, ''))}
                maxLength={8}
                disabled={buscando}
                style={styles.input}
                onKeyPress={(e) => e.key === 'Enter' && handleBuscar()}
              />
            </div>
            <button
              onClick={handleBuscar}
              disabled={isButtonDisabled}
              style={{
                ...styles.btnConsultar,
                opacity: isButtonDisabled ? 0.5 : 1,
                cursor: isButtonDisabled ? 'not-allowed' : 'pointer',
                backgroundColor: isButtonDisabled ? '#94a3b8' : '#3b82f6',
              }}
            >
              {buscando ? (
                <svg style={styles.spinner} fill="none" viewBox="0 0 24 24">
                  <circle style={styles.spinnerCircle} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path style={styles.spinnerPath} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
              ) : (
                <svg style={styles.btnIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              )}
              <span>{buscando ? 'Consultando' : 'Consultar'}</span>
            </button>
          </div>
        </div>

        {/* Toast Error */}
        {mensajeError && (
          <div style={styles.toast}>
            <svg style={styles.toastIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>{mensajeError}</span>
          </div>
        )}

        {/* Resultados */}
        {mostrarResultados && (
          <div style={styles.results}>
            {nombreCompleto && (
              <div style={styles.resultBox}>
                <div style={styles.resultLabel}>
                  <svg style={styles.resultIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  <span>NOMBRE COMPLETO</span>
                </div>
                <div style={styles.resultValue}>{nombreCompleto}</div>
              </div>
            )}

            {estadoAfiliacion && (
              <div style={styles.resultBox}>
                <div style={styles.resultLabel}>
                  <svg style={styles.resultIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>ESTADO DE AFILIACIÓN</span>
                </div>
                <div style={{
                  ...styles.estadoBadge,
                  backgroundColor: estadoAfiliacion.includes('Ya tiene') ? '#fef2f2' : '#f0fdf4',
                  color: estadoAfiliacion.includes('Ya tiene') ? '#dc2626' : '#059669',
                }}>
                  {estadoAfiliacion}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Botón Afiliar */}
        {mostrarBotonAfiliar && (
          <button onClick={() => mostrarToast('Iniciando afiliación...')} style={styles.btnAfiliar}>
            <svg style={styles.btnIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
            </svg>
            <span>Iniciar Afiliación</span>
          </button>
        )}
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @media (max-width: 640px) {
          .card-mobile { padding: 20px 16px !important; }
          .title-mobile { font-size: 18px !important; }
          .input-container-mobile { flex-direction: column !important; gap: 8px !important; }
          .btn-consultar-mobile { width: 100% !important; }
        }
      `}</style>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
    padding: '24px 16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '20px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    padding: '32px 24px',
    width: '100%',
    maxWidth: '440px',
    className: 'card-mobile',
  },
  header: {
    textAlign: 'center',
    marginBottom: '28px',
  },
  iconWrapper: {
    width: '56px',
    height: '56px',
    backgroundColor: '#eff6ff',
    borderRadius: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
  },
  icon: {
    width: '28px',
    height: '28px',
    color: '#3b82f6',
  },
  title: {
    fontSize: '20px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 6px 0',
    className: 'title-mobile',
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b',
    margin: 0,
  },
  // --- Estilos para la licencia ---
  licenciaContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#f1f5f9',
    borderRadius: '12px',
    padding: '12px 16px',
    marginBottom: '20px',
    border: '1px solid #e2e8f0',
  },
  licenciaItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
  },
  licenciaLabel: {
    fontSize: '11px',
    fontWeight: '600',
    textTransform: 'uppercase',
    color: '#64748b',
    letterSpacing: '0.05em',
  },
  licenciaValor: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#0f172a',
  },
  // --- Fin estilos licencia ---
  inputSection: {
    marginBottom: '20px',
  },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    color: '#475569',
    marginBottom: '8px',
    letterSpacing: '0.025em',
  },
  inputContainer: {
    display: 'flex',
    gap: '10px',
    className: 'input-container-mobile',
  },
  inputWrapper: {
    flex: 1,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  inputIcon: {
    position: 'absolute',
    left: '14px',
    width: '18px',
    height: '18px',
    color: '#94a3b8',
    pointerEvents: 'none',
  },
  input: {
    width: '100%',
    padding: '12px 14px 12px 42px',
    fontSize: '15px',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    outline: 'none',
    backgroundColor: '#f8fafc',
    transition: 'all 0.2s',
    fontWeight: '500',
  },
  btnConsultar: {
    padding: '12px 20px',
    color: '#ffffff',
    border: 'none',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    whiteSpace: 'nowrap',
    boxShadow: '0 1px 2px rgba(59, 130, 246, 0.3)',
    className: 'btn-consultar-mobile',
  },
  btnIcon: {
    width: '18px',
    height: '18px',
  },
  spinner: {
    width: '18px',
    height: '18px',
    animation: 'spin 1s linear infinite',
  },
  spinnerCircle: {
    opacity: 0.25,
  },
  spinnerPath: {
    opacity: 0.75,
  },
  toast: {
    backgroundColor: '#fef2f2',
    border: '1px solid #fecaca',
    color: '#dc2626',
    padding: '12px 14px',
    borderRadius: '10px',
    marginBottom: '20px',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    animation: 'fadeIn 0.3s ease',
  },
  toastIcon: {
    width: '18px',
    height: '18px',
    flexShrink: 0,
  },
  results: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginBottom: '20px',
  },
  resultBox: {
    backgroundColor: '#f8fafc',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    padding: '16px',
  },
  resultLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '12px',
    fontWeight: '600',
    color: '#64748b',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: '8px',
  },
  resultIcon: {
    width: '16px',
    height: '16px',
  },
  resultValue: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#1e293b',
    padding: '10px 12px',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    border: '1px solid #e2e8f0',
    lineHeight: '1.4',
  },
  estadoBadge: {
    fontSize: '15px',
    fontWeight: '600',
    padding: '10px 12px',
    borderRadius: '8px',
    textAlign: 'center',
    border: '1px solid transparent',
  },
  btnAfiliar: {
    width: '100%',
    padding: '14px 20px',
    backgroundColor: '#10b981',
    color: '#ffffff',
    border: 'none',
    borderRadius: '12px',
    fontSize: '15px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    boxShadow: '0 1px 2px rgba(16, 185, 129, 0.3)',
  },
};

export default Verificarcodigo;